export default "__VITE_ASSET__DfKpy5Pj__"